import { SxProps, Theme } from '@mui/material';

/**
 * Syncfusion grid container styles for approvals
 */
export const gridContainerStyles: SxProps<Theme> = {
  width: 1000,
  '& .e-grid': {
    border: 'none',
    boxShadow: 'none'
  },
  '& .e-gridheader': {
    backgroundColor: '#f1f5f9'
  },
  '& .e-headercell': {
    fontWeight: 600,
    color: '#374151',
    fontSize: '0.75rem',
    padding: '8px 6px',
    whiteSpace: 'nowrap'
  },
  '& .e-rowcell': {
    fontSize: '0.75rem',
    padding: '6px 6px'
  },
  '& .e-row:hover': {
    backgroundColor: '#f8fafc'
  }
};

/**
 * Action button styles
 */
export const actionButtonStyles = {
  base: {
    minWidth: 70,
    fontSize: '0.65rem',
    padding: '3px 6px',
  },
  act: {
    backgroundColor: '#3b82f6',
    '&:hover': {
      backgroundColor: '#2563eb'
    }
  },
  change: {
    backgroundColor: '#f59e0b',
    '&:hover': {
      backgroundColor: '#d97706'
    }
  },
  view: {
    borderColor: '#94a3b8',
    color: '#64748b',
    '&:hover': {
      borderColor: '#64748b',
      backgroundColor: '#f8fafc'
    }
  }
};
